/**
 * @author Jensen<zhhnch@gmail.com>
 * @description 外部配置
 * @since 2018/4/8
 */
module.exports = {
    test: true,
    myUrl: "",
    pc_domain: "https://dev.ukelink.net/",
    threeDSecureBtn: true,
    api_domain: "http://m.glocalme.com:3001",
    rent_url:"https://enroamingman.ukelink.net/cooperation/?simple"
};



//////////////////
// WEBPACK FOOTER
// ./config/app-config.js
// module id = D3Sj
// module chunks = 113